import { Controller, type Control, type FieldValues, type Path } from 'react-hook-form';
import { NumberField } from '@/components';

/** 明細セルの数値入力（Controller + NumberField） */
export function NumCell<V extends FieldValues>({
  control,
  name,
  label,
  decimals,
  unit,
  width = 'full',
  error,
}: {
  control: Control<V>;
  name: Path<V>;
  label: string;
  decimals?: number;
  unit?: string;
  width?: 'xs' | 'sm' | 'md' | 'lg' | 'full';
  error?: string;
}) {
  return (
    <>
      <Controller control={control} name={name} render={({ field }) => <NumberField {...field} aria-label={label} decimals={decimals} unit={unit} width={width} invalid={!!error} />} />
      {error && <div className="bs-plan-error">{error}</div>}
    </>
  );
}

/** 明細セルの下に出すエラー文言 */
export function CellError({ message }: { message?: string }) {
  return message ? <div className="bs-plan-error">{message}</div> : null;
}
